import React, { useEffect, useState } from 'react'; 
import { useNavigate } from 'react-router-dom';
import './style.css';


export const List0 = () => {
    const currentyear = new Date().getFullYear();
    const keyname = 'dataList' + currentyear;

    const navigate = useNavigate();
    const auth = sessionStorage.getItem('ID');
    const [jsonData, setJsonData] = useState([]);
    const [loading, setLoading] = useState({
        isEnabled:true,
        message:'データベースに接続中......'
    })
    
    const [filters, setFilters] = useState({
        Serial: '',
        Designer: '',
        DesignDate:'',
        Name:'',
        Unique: '',
        Subject: '',
        Status: '',
        Department: '',
        System:'',
        DesignReviewer:'',
        DesignApprover:'',
        Designer2:'',
        DesignReviewer2:'',
        DesignApprover2:'',
        TestOperator:'',
        TestReviewer:'',
        TestApprover:'',
        EquipmentAdmin:'',
        TestOperator2:'',
        TestReviewer2:'',
        TestApprover2:'',
        TaskHolderCode:'',
        TaskHolder:'',
        Year:'',
    });

    // 並び替えのためのステートを追加
    const [sortConfig, setSortConfig] = useState({
        key: 'Serial', // デフォルトはSerialで並び替え
        direction: 'ascending' // デフォルトは昇順
    });

    const uniqueOptions = [...new Set(jsonData.map(item => item.Unique))];
    const designerOptions = [...new Set(jsonData.map(item => item.Designer))];
    const designDateOptions = [...new Set(
        jsonData.map(item => item.DesignDate !== null ? item.DesignDate : "下書き")
      )];
    const nameOptions = [...new Set(jsonData.map(item => item.Name))];
    const subjectOptions = [...new Set(jsonData.map(item => item.Subject))];
    const serialOptions = [...new Set(jsonData.map(item => item.Serial))];
    const statusOptions = [...new Set(jsonData.map(item => item.Status))];
    const departmentOptions = [...new Set(jsonData.map(item => item.Department))];
    const systemOptions = [...new Set(jsonData.map(item => item.System))];
    const taskholderOptions = [...new Set(jsonData.map(item => item.TaskHolder))];


    //API設定
    // タイムアウト付きfetch関数
    async function fetchWithTimeout(url, options = {}, timeout = 5000) {
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchPromise = fetch(url, { ...options, signal });
        const timeoutId = setTimeout(() => {
            controller.abort();
        }, timeout);
        try {
            return await fetchPromise;
        } finally {
            clearTimeout(timeoutId);
        }
    }
    // 再トライ付きAPI呼び出し関数（GET/POST両対応）
    async function fetchAPI(url, options = {}, retries = 2, timeout = 5000) {
        let attempts = 0;
        let lastError = null;
        while (attempts < retries) {
            try {
                const response = await fetchWithTimeout(url, options, timeout);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return await response.json(); // 成功時にJSONデータを返す
            } catch (error) {
                lastError = error;
                attempts += 1;
                console.warn(`Attempt ${attempts} failed: ${error.message}`);
                if (attempts >= retries) {
                    throw lastError;
                }
            }
        }
    }


    useEffect(() => {
        if (!auth) {
            navigate('/login');
        }
    }, [auth, navigate]);

    useEffect(() => {
        document.title = 'LIST';
    }, []);

    const GetList = async () => {
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "データ読み込み中..." // メッセージの変更
        }));
        //const url = 'https://4576qwzryc.execute-api.ap-northeast-1.amazonaws.com/test/api'; 
        const queryParams = new URLSearchParams({year:currentyear}).toString();
        const url = `https://4576qwzryc.execute-api.ap-northeast-1.amazonaws.com/test/api?${queryParams}`;
        const options = {
            method: 'GET', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try {
            const json = await fetchAPI(url, options);

            setJsonData(json);
            
            console.log('keyname:::',keyname);
            sessionStorage.setItem(keyname, JSON.stringify(json));
            console.log("GetList:::",json);
        } catch (error) {
            console.error('API呼び出しエラー:', error);
            alert(`API呼び出しエラー: ${error.message}`);
        } finally {
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                message:"取得完了"
            }));
        }
    };
    useEffect(() => {
        const datalist = sessionStorage.getItem(keyname);
        if (datalist && datalist != 'null') { //依頼表力リンク時にNullで生成されるため。その状態でlistに遷移するとmapできずエラーとなるため回避
            setJsonData(JSON.parse(datalist));
            console.log("リスト取得完了");
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                message:"取得完了"
            }));
        } else {
            GetList();
        }
    }, []);

    /*部員、承認者リスト取得 */
    const GetAuthList = async() =>{
        const authListStr = sessionStorage.getItem('authListStr')
        if(authListStr != null){
            console.log("承認者リスト取得済み")
            return;
        }
        console.log("承認者リストを取得")
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "リスト読み込み中..." // メッセージの変更
        }));
        const url = 'https://91irq05y3c.execute-api.ap-northeast-1.amazonaws.com/auth/api';
        const options = {
            method: 'GET', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try{
            const json = await fetchAPI(url,options);
            sessionStorage.setItem('authListStr',JSON.stringify(json));
            console.log("authlist:::",json);//JSON.parse(sessionStorage.getItem('authListStr'));
        }
        catch{
            console.log('auth list取得失敗')
        }finally{
            if(sessionStorage.getItem('dataList')){
                setLoading(prevState => ({
                    ...prevState,
                    isEnabled:false,
                    }));
            }
            
        }
    }

    useEffect(() => {
        const authlist = sessionStorage.getItem('authListStr');
        if (authlist && authlist != 'null') { //依頼表力リンク時にNullで生成されるため。その状態でlistに遷移するとmapできずエラーとなるため回避
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                message:"取得完了"
            }));
        } else {
            GetAuthList();
        }
    }, []);

    console.log("jsonData:::",jsonData);
    const filteredData = jsonData.filter(item => {
        return (
            (filters.Serial === '' || (item.Serial && item.Serial === filters.Serial)) &&
            (filters.Designer === '' || (item.Designer && item.Designer === filters.Designer)) &&
            (filters.DesignDate === '' || (item.DesignDate ? item.DesignDate === filters.DesignDate : filters.DesignDate === '下書き')) &&
            (filters.Name === '' || (item.Name && item.Name === filters.Name)) &&
            (filters.Unique === '' || (item.Unique && item.Unique.toString() === filters.Unique)) &&
            (filters.Subject === '' || (item.Subject && item.Subject === filters.Subject)) &&
            (filters.Status === '' || (item.Status && item.Status === filters.Status)) &&
            (filters.Department === '' || item.Department === filters.Department) &&
            (filters.System === '' || item.System === filters.System) &&
            (filters.DesignReviewer === '' || (item.DesignReviewer && item.DesignReviewer === filters.DesignReviewer)) &&
            (filters.DesignApprover === '' || (item.DesignApprover && item.DesignApprover === filters.DesignApprover)) &&
            (filters.TestReviewer === '' || (item.TestReviewer && item.TestReviewer === filters.TestReviewer)) &&
            (filters.TestApprover === '' || (item.TestApprover && item.TestApprover === filters.TestApprover)) &&
            (filters.EquipmentAdmin === '' || (item.EquipmentAdmin && item.EquipmentAdmin === filters.EquipmentAdmin)) &&
            (filters.TestOperator === '' || (item.TestOperator && item.TestOperator === filters.TestOperator)) &&
            (filters.TestReviewer2 === '' || (item.TestReviewer2 && item.TestReviewer2 === filters.TestReviewer2)) &&
            (filters.TestApprover2 === '' || (item.TestApprover2 && item.TestApprover2 === filters.TestApprover2)) &&
            (filters.Designer2 === '' || (item.Designer2 && item.Designer2 === filters.Designer2)) &&
            (filters.DesignReviewer2 === '' || (item.DesignReviewer2  && item.DesignReviewer2 === filters.DesignReviewer2)) &&
            (filters.DesignApprover2 === '' || (item.DesignApprover2 && item.DesignApprover2 === filters.DesignApprover2)) &&
            (filters.Year === '' || (item.Year && item.Year === filters.Year)) 
        );
    });
    console.log("filteredData:::",filteredData);
    


    const statusMapping = {
        '1': '申請待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '2': '検討待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '3': '承認待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '4': '受付待ち<br /><span style="font-size: .8em;"> (実験G)</span>',
        '5': '承認待ち<br /><span style="font-size: .8em;"> (実験G)</span>',
        '6': '確認待ち<br /><span style="font-size: .8em;">（試験実施者）</span>',
        '7': '打合せ待ち<br /><span style="font-size: .8em;">（設備管理者）</span>',
        '8': '試験完了待ち<br /><span style="font-size: .8em;">（試験実施者）</span>',
        '9': '検討待ち<br /><span style="font-size: .8em;">（実験G）</span>',
        '10': '承認待ち<br /><span style="font-size: .8em;">（実験G）</span>',
        '11': '結果確認待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '12': '検討待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '13': '承認待ち<br /><span style="font-size: .8em;">（依頼部署）</span>',
        '14': '完了<br /><span style="font-size: .8em;">（試験実施済）</span>',
        '15': '中止<br /><span style="font-size: .8em;">（試験未実施）</span>',
    };

    const taskMapping = {
        '1': 'Designer',
        '2': 'DesignReviewer',
        '3': 'DesignApprover',
        '4': 'TestReviewer',
        '5': 'TestApprover',
        '6': 'TestOperator',
        '7': 'EquipmentAdmin',
        '8': 'TestOperator',
        '9': 'TestReviewer2',
        '10': 'TestApprover2',
        '11': 'Designer2',
        '12': 'DesignReviewer2',
        '13': 'DesignApprover2',
        '14': 'none',
        '15': 'none',
    }

////////////////////////////////
//現在のタスク保持者を確定する(jsonに追加)
/////////////////////////////////
    const alist = JSON.parse(sessionStorage.getItem('authListStr'));
 // JSON データを変換する関数
 const transformJson = (data, mapping, users) => {
    // ユーザー配列が存在しない場合、空のオブジェクトを使用
    const userLookup = Array.isArray(users)
    ? users.reduce((acc, curr) => {
        acc[curr.ID] = curr.Name; // ID をキー、Name を値として設定
        return acc;
        }, {})
    : {}; // users が無効なら空のオブジェクト

    // 各 JSON アイテムを変換
    return data.map((item) => {
      const keyForStatus = mapping[item.Status]; // Status に対応するキーを取得
      const taskHolderId = item[keyForStatus]; // 対応するキーの値を取得
      const taskHolderName = userLookup[taskHolderId] || "Unknown"; // ユーザー名に変換 (存在しない場合は "Unknown")
      return {
        ...item, // 元のアイテムを保持
        TaskHolder: taskHolderName, // taskHolder を追加
      };
    });
  };
  // 変換後の JSON データを取得
  const updatedJson = transformJson(filteredData, taskMapping, alist);
  console.log("updatedJson:::",updatedJson);




    // 並び替えの処理
    const sortedData = updatedJson
    .filter(item =>  //下書きデータを除外
            item.DesignDate !== "" &&
            item.Status !== "1"
        )
    .sort((a, b) => {
        const aValue = a[sortConfig.key] ? a[sortConfig.key] : '';
        const bValue = b[sortConfig.key] ? b[sortConfig.key] : '';

        // 並び替えの方向を考慮
        if (aValue < bValue) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
    };

    // 並び替えの変更ハンドラー
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    
    

    return (
        <>
        {loading.isEnabled && (
            <div className="spinner-overlay">
                <div className="spinner"></div>
                <div className="loading-text">{loading.message}</div>
            </div>
        )}
        <div style={{ marginTop: "70px" }}></div>

            
        <h1>申請状況（{currentyear}年作成分）</h1>
        <button name="reload" onClick={() => GetList()} className='list-button'>リスト更新</button>
        {loading.isEnabled ? (
            <p>Loading...</p>
        ) : (
            <table border="1" cellPadding="10" cellSpacing="0">
                <thead>
                    <tr>
                        <th>
                            <button onClick={() => requestSort('DesignDate')}>申請日</button>
                            <select name="DesignDate" value={filters.DesignDate} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {designDateOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>

                        <th>
                            <button onClick={() => requestSort('Serial')}>依頼No</button>
                            <select name="Serial" value={filters.Serial} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {serialOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('Department')}>部署名</button>
                            <select name="Department" value={filters.Department} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {departmentOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('Name')}>起票者</button>
                            <select name="Name" value={filters.Name} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {nameOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('Subject')}>試験名</button>
                            <select name="Subject" value={filters.Subject} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {subjectOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('System')}>製品名</button>
                            <select name="System" value={filters.System} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {systemOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('Status')}>進捗ステータス</button>
                            <select name="Status" value={filters.Status} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {statusOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        <th>
                            <button onClick={() => requestSort('TaskHolder')}>タスク保持者</button>
                            <select name="TaskHolder" value={filters.TaskHolder} onChange={handleFilterChange}>
                                <option value="">All</option>
                                {taskholderOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </select>
                        </th>
                        
                        
                    </tr>
                </thead>
                <tbody>
                    {sortedData.length > 0 ? (
                        sortedData.map((item, index) => (
                            <tr key={index} onClick={() => window.location.href = `/form?unique=${item.Year + item.Unique}`}>
                            <td>{item.DesignDate ? item.DesignDate : '下書き'}</td>
                            <td>
                                {item.Serial ? item.Serial : 'N/A'}
                            </td>
                            <td>{item.Department}</td>
                            <td>{item.Name}</td>
                            <td>{item.Subject}</td>
                            <td>{item.System}</td>
                            <td dangerouslySetInnerHTML={{
                                __html: statusMapping[item.Status] || item.Status
                            }}></td>
                            <td>{item.TaskHolder}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5">データ読み込み中...</td>
                        </tr>
                    )}
                </tbody>
            </table>
        )}
        </>
    );
};